import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { SystemPurchaseOrderManagement as SystemPurchaseOrderManagementPage } from '../SystemPurchaseOrderManagement/system_purchase_order_management.component';

/**
 * System Admin Invoice Management -> Purchase Order Management
 * Separate route + permission gating.
 * Note: currently reuses existing PO Management UI.
 */
export default function SystemPurchaseOrderManagement() {
  const navigate = useNavigate();
  const permissionNames = useMemo(() => {
    try {
      const stored = localStorage.getItem('permissions');
      if (!stored) {
        return [];
      }
      const parsed = JSON.parse(stored);
      return Array.isArray(parsed) ? parsed.map((p) => p.name) : [];
    } catch (error) {
      console.error('Failed to parse permissions:', error);
      return [];
    }
  }, []);

  useEffect(() => {
    if (!permissionNames.includes('System Invoice Management')) {
      navigate('/rov', { replace: true });
    }
  }, [permissionNames, navigate]);

  return <SystemPurchaseOrderManagementPage />;
}
